/**
 * Short sample lines for ElevenLabs preview (kept brief for cost).
 */
export function sampleTextForVoicePreview(characterName: string, isNarrator: boolean): string {
  if (isNarrator) return "Let us begin the story.";
  const n = characterName.trim().toLowerCase();
  if (n.includes("gatsby")) return "Old sport, I hope you'll come by tonight.";
  if (n.includes("daisy")) return "I'm glad to see you again.";
  if (n === "tom" || n.startsWith("tom ") || n.includes("tom buchanan")) return "Now listen here.";
  return "Hello, this is my voice for the story.";
}
